<form [ngClass]="params.themed ? 'component-dialog-style' : ''">
	<div class="modal-header">
		@if (params.headerIconClass) {
			<span [ngClass]="params.headerIconClass" class="glyphicons" [attr.icon-type]="params.headerIconType">
			</span>
		}
		<h4 id="modal-title" class="header-title">
			{{params.title}}&nbsp;
		</h4>
		@if (params.cancelText) {
			<button type="button" class="close float-right btn btn-transparent" (click)="hide()" [attr.aria-label]="'Close' | translate">
				<span class="glyphicons remove_2"></span>
			</button>
		}
	</div>
	<div id="modal-body" class="modal-body" [ngClass]="[
			params.messageBodyClass ? params.messageBodyClass : ''
		]">
		@if (params.htmlMessage) {
			<div [innerHTML]="params.htmlMessage">
			</div>
		} @else {
			<div>
				{{params.message}}
			</div>
		}

		@if (params.rememberText) {
			<vb-ui-checkbox class="remember-checkbox" [(ngModel)]="remember">
				{{ params.rememberText }}
			</vb-ui-checkbox>
		}
	</div>

	@if (params.themed) {
		<div class="modal-footer">
			<button [hidden]="!params.cancelText" (click)="hide()" vbBtnSecondary>
				{{params.cancelText}}
			</button>

			<button [hidden]="!params.secondaryActionText" (click)="onActionInternal(ConfirmationDialogAction.SECONDARY)" vbBtnSecondary>
				{{params.secondaryActionText}}
			</button>

			<button type="submit" [hidden]="!params.actionText" (click)="onActionInternal(ConfirmationDialogAction.PRIMARY)" vbAutoFocus vbBtnPrimary>
				{{params.actionText}}
			</button>
		</div>
	} @else {
		<div class="modal-footer">
			<button [hidden]="!params.cancelText" (click)="hide()" vbBtnWhite>
				{{params.cancelText}}
			</button>

			<button [hidden]="!params.secondaryActionText" (click)="onActionInternal(ConfirmationDialogAction.SECONDARY)" vbBtnWhite>
				{{params.secondaryActionText}}
			</button>

			<button type="submit" [hidden]="!params.actionText" (click)="onActionInternal(ConfirmationDialogAction.PRIMARY)" vbAutoFocus vbBtnPrimary>
				{{params.actionText}}
			</button>
		</div>
	}
</form>
